import React from "react";
import Img1 from "../../assets/ThreeDscan/Marquee/Marquee Img 3D Scanning Koios Engineering Solutions (1).webp";
import Img2 from "../../assets/ThreeDscan/Marquee/Marquee Img 3D Scanning Koios Engineering Solutions (2).webp";
import Img3 from "../../assets/ThreeDscan/Marquee/Marquee Img 3D Scanning Koios Engineering Solutions (3).webp";
import Img4 from "../../assets/ThreeDscan/Marquee/Marquee Img 3D Scanning Koios Engineering Solutions (4).webp";
import Img5 from "../../assets/ThreeDscan/Marquee/Marquee Img 3D Scanning Koios Engineering Solutions (5).webp";
import Img6 from "../../assets/ThreeDscan/Marquee/Marquee Img 3D Scanning Koios Engineering Solutions (6).webp";
import Img7 from "../../assets/ThreeDscan/Marquee/Marquee Img 3D Scanning Koios Engineering Solutions (7).webp";
import Img8 from "../../assets/ThreeDscan/Marquee/Marquee Img 3D Scanning Koios Engineering Solutions (8).webp";
import Img9 from "../../assets/ThreeDscan/Marquee/Marquee Img 3D Scanning Koios Engineering Solutions (9).webp";

function Marquee() {
  return (
    <div className="threeD-banner-wrapper">
      <div className="threeD-banner-marquee">
        <img src={Img1} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img2} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img3} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img4} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img5} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img6} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img7} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img8} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img9} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img1} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img2} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img3} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img4} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img5} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img6} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img7} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img8} alt="Koios Engineering Solution Marquee Img" />
        <img src={Img9} alt="Koios Engineering Solution Marquee Img" />
      </div>
    </div>
  );
}

export default Marquee;
